export { renderSearchBox_unstable as renderSearchBox } from '@fluentui/react-search';
